import { getUser } from '../authentication/selectors';
import { setUserMonthBonusApi } from './graphql/setUserMonthBonusApi';
import { setStateAllUserMonthBonusesApprovalsApi } from './graphql/setStateAllUserMonthBounsApi';
import {
  getBonusMonth, getSupervisorId, getUserId,
} from './selectors';

import { nextId } from '../../utils';

export const types = {
  SET_USER_MONTH_BONUS_ID: 'bonusApprovals/SET_USER_MONTH_BONUS_ID',
  SET_BONUS_MONTH: 'bonusApprovals/SET_BONUS_MONTH',
  SET_SUPERVISOR_ID: 'bonusApprovals/SET_SUPERVISOR_ID',
  SET_USER_ID: 'bonusApprovals/SET_USER_ID',
  SET_USER_ID_STATE: 'bonusApprovals/SET_USER_ID_STATE',
};

export const setUserBonusMonthId = (userBonusMonthId) => {
  return {
    type: types.SET_USER_MONTH_BONUS_ID,
    userBonusMonthId,
  };
};
export const setUserIdState = (userIdState) => {
  return {
    type: types.SET_USER_ID_STATE,
    userIdState,
  };
};

export const setBonusMonth = (monthDate) => {
  return {
    type: types.SET_BONUS_MONTH,
    bonusMonth: monthDate,
  };
};

export const setSupervisorId = (supervisorId) => {
  return {
    type: types.SET_SUPERVISOR_ID,
    supervisorId,
  };
};

export const setUserId = (userId) => {
  return {
    type: types.SET_USER_ID,
    userId,
  };
};

export const setDefaultSupervisorId = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const user = getUser(state);

    dispatch(setSupervisorId(user.id));
  };
};

export const setUserMonthBonus = (userTicketBonusArray) => {
  return async (dispatch, getState, { client }) => {
    await setUserMonthBonusApi(client, userTicketBonusArray);
  };
};

export const setStateAllUserMonthBonuses = (allUserMonthBonusesId, setNextState) => {
  return async (dispatch, getState, { client }) => {
    /* TODO: bonusMonth, districtId, departmnetId, summaryState, supervisorId */

    const state = getState();
    const bonusMonth = getBonusMonth(state);
    const supervisorId = getSupervisorId(state);
    const userId = getUserId(state);
    const { oldCollection } = await setStateAllUserMonthBonusesApprovalsApi(
      client,
      allUserMonthBonusesId,
      setNextState,
      bonusMonth,
      supervisorId,
      userId,
    );

    const nextUserId = nextId(oldCollection, userId);
    dispatch(setUserId(nextUserId));
  };
};
